type ImageBannerStep = {
  description?: string;
  key: ImageBannerStepsEnums;
  title: string;
};

export enum ImageBannerStepsEnums {
  configuration = 'configuration',
  schedule = 'schedule',
  confirm = 'confirm',
}

export enum ImageBannerStepsStatus {
  current = 'current',
  complete = 'complete',
  incomplete = 'incomplete',
}

const imageBannerStepConfiguration: ImageBannerStep = {
  description: 'Select the platforms and images for your image banner.',
  key: ImageBannerStepsEnums.configuration,
  title: 'Image Banner Details',
};

const imageBannerStepSchedule: ImageBannerStep = {
  description: 'Select when the image banner should be published and define the schedule.',
  key: ImageBannerStepsEnums.schedule,
  title: 'Schedule',
};

const imageBannerStepConfirm: ImageBannerStep = {
  description: 'Review your image banner choices and publish to your menu.',
  key: ImageBannerStepsEnums.confirm,
  title: 'Confirm',
};

export const imageBannerSteps: ImageBannerStep[] = [
  imageBannerStepConfiguration,
  imageBannerStepSchedule,
  imageBannerStepConfirm,
];

/**
 * Returns the image banner steps with schedule step conditionally included based on feature flag
 */
export function getImageBannerSteps(includeSchedule: boolean): ImageBannerStep[] {
  if (includeSchedule) {
    return imageBannerSteps;
  }

  return [imageBannerStepConfiguration, imageBannerStepConfirm];
}
